import React, { useState, useEffect } from 'react'
import { Box, Flex, Group, Button, Input, Tabs, Text, Image, TextInput, Paper } from '@mantine/core'
import { Dropzone } from '@mantine/dropzone'
import { IconPhotoPlus } from '@tabler/icons-react'
import { updateSourcingRequest } from '../../../services/sourcing-request'
import { notificationSuccess, notificationError } from '../../ui/Notifications'
import NoImage from '../../../assets/img/images/no-images.png'


const formValidation = {
  image: {
    isError: false,
    message: ''
  }
}

const FormUploadImages = ({ dataSourcingRequest, onCloseModal, reloadList }) => {
  const [selectedTab, setSelectedTab] = useState('upload')
  const [validationForm, setValidationForm] = useState(formValidation)
  const [loadingForm, setLoadingForm] = useState(false)
  const [imageUpload, setImageUpload] = useState(null)
  const [imageURL, setImageURL] = useState('')
  const [recentImage, setRecentImage] = useState(null)

  const submitUploadImage = async () => {
    setLoadingForm(true)
    let isError = false
    if (selectedTab === 'upload' && validationForm.image.isError) {
      isError = validationForm.image.isError
    }
    if (isError) {
      notificationError('Upload Image Sourcing Request Error', `${validationForm.image.message}`)
      setLoadingForm(false)
      return
    }
    let payload = {}
    if (selectedTab === 'upload') {
      payload = {
        request_number: dataSourcingRequest.request_number,
        title: dataSourcingRequest.title,
        brand: dataSourcingRequest.brand,
        quantity: dataSourcingRequest.quantity,
        quantity_unit: dataSourcingRequest.quantity_unit,
        currency: dataSourcingRequest.currency,
        price: dataSourcingRequest.price,
        user_id: dataSourcingRequest.user_id,
        agent_id: dataSourcingRequest.agent_id,
        description: dataSourcingRequest.description,
        image_encoded: imageUpload
      }
    } else {
      payload = {
        request_number: dataSourcingRequest.request_number,
        title: dataSourcingRequest.title,
        brand: dataSourcingRequest.brand,
        quantity: dataSourcingRequest.quantity,
        quantity_unit: dataSourcingRequest.quantity_unit,
        currency: dataSourcingRequest.currency,
        price: dataSourcingRequest.price,
        user_id: dataSourcingRequest.user_id,
        agent_id: dataSourcingRequest.agent_id,
        description: dataSourcingRequest.description,
        image_url: imageURL
      }
    }
    try {
      const response = await updateSourcingRequest(dataSourcingRequest.id, payload)
      if (response.success) {
        onCloseModal()
        reloadList()
        notificationSuccess('Update Sourcing Request Successfully', 'You have been updated data sourcing request')
      }
    } catch (error) {
      console.log(error)
      const errorMessage = error.response.data.message
      const captionMessageError = Object.keys(errorMessage) ? errorMessage : 'Please recheck your form'
      notificationError('Update Sourcing Request Error', captionMessageError)
    } finally {
      setLoadingForm(false)
    }
  }

  useEffect(() => {
    if (selectedTab === 'upload') {
      setImageURL('')
    } else {
      setImageUpload(null)
    }
  }, [selectedTab])

  useEffect(() => {
    if (dataSourcingRequest) {
      handleSetForm(dataSourcingRequest)
    }
  }, [dataSourcingRequest])

  const handleSetForm = (value) => {
    setRecentImage(value.images)
  }

  const handleUploadImage = (file) => {
    setValidationForm(formValidation)
    const fileEncoded = file[0]
    const fileReader = new FileReader()
    fileReader.readAsDataURL(fileEncoded)
    fileReader.onload = (reader) => {
      setImageUpload(reader.target.result)
    }
  }

  const handleErrorFile = (file) => {
    setValidationForm(formValidation)
    const fileState = Object.values(file)
    const errorMessage = fileState[0].errors[0].message
    if (errorMessage) {
      const error = {
        image: {
          isError: true,
          message: errorMessage
        }
      }
      setValidationForm(error)
    }
  }

  const handleSelectedImage = () => {
    if (selectedTab === 'upload' && imageUpload !== null) {
      return imageUpload
    } else if (selectedTab === 'url' && imageURL !== '') {
      return imageURL
    } else if (recentImage) {
      return recentImage
    }
    return NoImage
  }
  
  return (
    <Box>
      <Box h={300} mb='md'>
        <Tabs size='xs' my={4} value={selectedTab} onChange={setSelectedTab}>
          <Tabs.List>
            <Tabs.Tab value="upload">Upload Image File</Tabs.Tab>
            <Tabs.Tab value="url">Upload Image URL</Tabs.Tab>
          </Tabs.List>
          <Tabs.Panel value="upload">
            <Input.Wrapper my={10} label='Upload Product Photo (Optional)' size='xs' error={validationForm.image.isError ? `${validationForm.image.message}` : ''}>
              <Box my={10}>
                <Dropzone 
                  accept={[
                    'image/png',
                    'image/jpeg',
                    'image/gif',
                  ]}
                  onDrop={(files) => handleUploadImage(files)}
                  onReject={(files) => handleErrorFile(files)}
                  maxSize={2000000}
                >
                  <Box ta='center' my={30}>
                    <Flex justify='center' mb={10}>
                      <IconPhotoPlus size={50} color='gray' />
                    </Flex>
                    <Box>
                      <Text fz={12} c='blue.9'>Upload Image Here</Text>
                      <Text fz={12} c='gray.6'>PNG, JPG, GIF up to 2 MB</Text>
                    </Box>
                  </Box>
                </Dropzone>
              </Box>
            </Input.Wrapper>
          </Tabs.Panel>
          <Tabs.Panel value="url">
            <Box my={10}>
              <TextInput
                name='imageURL'
                value={imageURL}
                label='Image URL'
                placeholder='Input image URL'
                onChange={(val) => setImageURL(val.target.value)}
                size='xs'
              />
            </Box>
          </Tabs.Panel>
        </Tabs>
      </Box>
      <Box mb='md'>
        <Text fz={12} fw='500' mb='sm'>Recent / Review Image</Text>
        <Paper shadow="sm" withBorder radius='md' style={{ backgroundColor: '#f1f2f5' }}>
          <Flex justify='center'>   
            <Image src={handleSelectedImage()} w='auto' radius='md' h={250} fit='contain' />
          </Flex>
        </Paper>
      </Box>
      <Box mt={20}>
        <Flex justify='flex-end'>
          <Group>
            <Button size='xs' variant="outline" onClick={onCloseModal}>Close</Button>
            <Button size='xs' loading={loadingForm} variant="filled" onClick={() =>submitUploadImage()} disabled={imageUpload === null && imageURL === ''}>Submit</Button>
          </Group>
        </Flex>
      </Box>
    </Box>
  )
}

export default FormUploadImages